module.exports = __webpack_public_path__ + "static/media/logo.f1137ab8.png";